<template>
  <section id="section-3">
    <div class="header bg-gradient-success pb-6 pb-8 pt-5 pt-md-8">
      <h4 class="profile-section-title">
        <i class="ni ni-credit-card"></i> تراکنش ها
      </h4>
      <div class="row align-items-center justify-content-center">
        <div class="col-lg-4 text-center"></div>
        <div class="d-block d-lg-none p-2"></div>
        <div class="col-lg-6">
          <div class="row justify-content-center"></div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt--7">
      <div class="card">
        <div class="card-header border-0">
          <div class="row align-items-center">
            <div class="col">
              <h3 class="mb-0">سابقه تراکنش ها</h3>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table tablesorter" v-if="!isLoading">
              <thead class="thead-light">
                <tr>
                  <th>تاریخ</th>
                  <th>نوع تراکنش</th>
                  <th>ارزش ریالی</th>
                  <th>امتیاز</th>
                  <th>توضیحات</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in customerTransactionList">
                  <tr>
                    <td>
                      {{ item.transactionDate }}
                    </td>
                    <td v-if="item.scoreType === 0">افزایش</td>
                    <td v-else>  کاهش</td>

                    <td v-if="item.scoreType === 0">
                      {{ item.valueAmount | numFormat }}
                      <span style="color: green">+</span>
                    </td>
                    <td v-else>
                      {{ item.valueAmount | numFormat }}
                      <span style="color: red">-</span>
                    </td>
                    <td v-if="item.scoreType === 0">
                      {{ item.score }} <span style="color: green"> +</span>
                    </td>

                    <td v-else>
                      {{ item.score }}
                      <span style="color: red"> -</span>
                    </td>
                    <td>{{ item.description }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import store from "../store/index";
import loadingBar from "../../../components/loading/pdkLoadingBar";

export default {
  name: "Scors",
  store,
  components: { loadingBar },
  data() {
    return {
      isLoading: false,
      hasShowResult: false,
      score: 0,
      segment: "bronz",
      scorePercent: "",
      persent: "",
      descptData: "",
      card: "",
      userId: "",
      customerTransactionList: [],
    };
  },
  created() {
    this.userId = localStorage.getItem("UserId");
    this.getCustomerTransactionsByProfileId();
  },

  methods: {
    async getCustomerTransactionsByProfileId() {
      this.isLoading = true;
      const res = await this.$store.dispatch(
        "getCustomerTransactionsByProfileId",
        this.userId
      );
      this.customerTransactionList = res.data.queryResult;
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.page-item.active .page-link {
  z-index: 1;
  color: #fff !important;
  background-color: #2a69b1 !important;
  border-color: #2a69b1 !important;
}
.btn-profile {
  width: 180px !important;
}
.btn-align {
  /* text-align: center; */
  margin-top: 20px !important;

  /* padding-right: 70px !important;
  padding-left: 70px !important; */
}
.icon-top {
  margin-top: 38px;
  font-size: 40px;
}
.icon-bottom {
  margin-top: 38px;
  font-size: 22px;
}
.icon-position {
  float: left;
  margin-left: 26px;
}

.td-opened {
  background-color: rgb(4 112 167) !important;
  color: white;
}
.loading {
  height: 1000px !important;
  text-align: center !important;
  margin-top: 200px !important;
}
h3 {
  color: #777 !important;
}
</style>